var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":"Disbursement History"}},[_c('div',{staticClass:"chart-container",staticStyle:{"position":"relative","height":"250px","margin":"auto"}},[_c('canvas',{ref:"disbursementChart"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }